import { SESSION_LOCATION } from '../../components/schedule/helpers/scheduleHelpers'
import { conferenceConfig } from '../../config'
import { getNowTimestamp } from './dateTimeHelpers'

export default function getSessionAvailability({
  isSeries,
  startTimestamp,
  conferenceYear: conferenceYearStr,
  now = getNowTimestamp(),
}) {
  const conferenceYear = conferenceYearStr ? parseInt(conferenceYearStr, 10) : null
  let canShowVideo = false
  let actualStartTimestamp = startTimestamp ?? null
  const conferenceStartYear = new Date(conferenceConfig.startTimestamp).getFullYear()

  if (!startTimestamp) {
    // No session start time passed from BS
    if (now < conferenceConfig.startTimestamp && conferenceYear >= conferenceStartYear) {
      // If current date is before event start time AND sessionConferenceYear
      // is greater or equal to conferenceStartYear, put up the countdown
      actualStartTimestamp = conferenceConfig.startTimestamp
    }
  }

  if (!isSeries) {
    if (now >= actualStartTimestamp) {
      canShowVideo = true
    }
  } else {
    canShowVideo = true // There is no need to show countdowns on series overview videos
  }

  return { canShowVideo, actualStartTimestamp }
}

export const isInPerson = (item) =>
  [item?.sessionLocation, item?.promo?.sessionLocation].includes(SESSION_LOCATION.inperson)

export const isContentAvailable = ({ item, now = getNowTimestamp() }) => {
  const sessionDate = item?.date

  if (isInPerson(item)) {
    return false
  }

  if (!sessionDate) {
    if (item?.conferenceYear === conferenceConfig.year) {
      return conferenceConfig.startTimestamp <= now
    }
    return item?.conferenceYear < conferenceConfig.year
  }
  return sessionDate <= now
}
